import { Controller } from '@hotwired/stimulus';
import { debounce } from '@inked/utilities';

export class AutoSubmitController extends Controller {
  static values = {
    delay: {
      type: Number,
      default: 150,
    },
  };

  connect() {
    this.requestSubmit = debounce(() => this.element.requestSubmit(), this.delayValue);
  }

  submit() {
    this.requestSubmit();
  }
}
